import { Box, useCircleSize } from "arkh";
import React from "react";

export function TodoListItemNewFooterContainer(props: {
  children: React.ReactNode;
}) {
  const size = useCircleSize("smallMedium");
  return (
    <Box spaceTop="xsmall" spaceBottom="small">
      <Box
        style={[
          {
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            minHeight: size,
          },
        ]}
      >
        {props.children}
      </Box>
    </Box>
  );
}
